import {BaseFormModel} from './base-form-model';
import {MenuModifierGroupModifier} from './menu-modifier-group-modifier';
import {MenuModifierGroupSelection} from './menu-modifier-group-selection';

export class MenuModifierGroup extends BaseFormModel<MenuModifierGroup> {
    id: number;
    name: string;
    description: string;
    modifiers: MenuModifierGroupModifier[];
    selections: MenuModifierGroupSelection[];
}
